<template>
    <div class="file-list-wrap">
        <div class="file-table">
            <el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle" :height="PAGESIZE.h-340" >
                <el-table-column type="index" label="序号"> </el-table-column>
                <el-table-column prop="orderRemark" label="报价须知" align="center"> </el-table-column>
                <el-table-column prop="" label="操作" width="100" v-if="orderInfo && orderInfo.orderState == 1 && checkRole('cgy_role')">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :visible.sync="openDialog" width="800px" :title="title" :close-on-click-modal="false">
            <el-form label-width="110px" ref="form" :model="form" :rules="rules" size="small">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="报价须知" prop="orderRemark">
                            <el-input type="textarea" :autosize="{ minRows: 4 }" maxlength="200" v-model="form.orderRemark" placeholder="请输入报价须知" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="openDialog = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { inquiryNoteList,addInquiryNote,editInquiryNote,delInquiryNote } from '@/api/srm/inquiryDetail.js';
export default {
    props:['orderInfo'],
    data(){
        return {
            tableData:[],
            openDialog:false,
            title:'',
            form:{
                id:'',
                orderRemark:'',
                orderId:this.$route.query.hId,
            },
            rules:{
                 orderRemark: [{ required: true, message: '请输入报价须知内容',  trigger: 'blur' }],
            }
        }
    },
    mounted(){
        this.getFileList();
    },
    methods:{
        async getFileList() {
            let _this = this;
            const {
                data: res
            } = await inquiryNoteList({
					page: 1, //当前页码
                    limit: 1000, //当前每页显示的数量
					objMap: {
						orderId:_this.$route.query.hId,
					}
                })
            if (res.code == 0) {
                _this.tableData = res.data || [];
            }
        },
        // 表单重置
        reset: function() {
            this.form = {
                id:undefined,
                orderRemark:'',
                orderId:this.$route.query.hId,
            }
            if (this.$refs["form"] !== undefined) {
                this.$refs["form"].resetFields();
            }
        },
        // 编辑
        handleEdit:function(row){
            this.reset();
            this.form.id=row.id;
            this.form.orderRemark=row.orderRemark;
            this.title = '编辑'
            this.openDialog = true;
        },
        // 删除
        handleDel:function(row){
            let _this = this;
            _this.confirm({
                text: '确认删除吗',
                tip: '警告',
                type: '',
                fn: function(param) {
                    delInquiryNote(param).then(response => {
                        if (response.data.code === 0) {
                            _this.$success(response.data.msg);
                            _this.getFileList();
                        } else {
                            _this.$fail(response.data.msg);
                        }
                    });
                },
                data: {
                    id: row.id
                } //参数对象 主要回调函数用
            });
        },
        // 新增
        addNotice(){
            this.reset();
            this.title = '新增'
            this.openDialog = true;
        },
        // 提交
        submitForm(){
            let _this = this;
            _this.$refs['form'].validate((valid) => {
                if (valid) {
                    let curForm = {..._this.form};
                    if (_this.form.id ){    // 编辑
                        editInquiryNote(curForm).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                _this.getFileList();
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    }else{  // 新增
                        delete curForm.id
                        addInquiryNote(curForm).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                _this.getFileList();
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    }
                }
            })
        },
    },
    computed:{
        PAGESIZE:function(){
            return this.$store.getters['app/sizeInfo'];
        },
    },
}
</script>
<style lang="sass" scoped>

</style>
